import * as React from "react";
const SvgFiRrRabbit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rabbit_svg__a)">
      <path
        fill="#062147"
        d="M23 22h-2V11.538c1.719-.584 3-1.737 3-3.538 0-2.402-2.254-5.872-5.804-5.996C17.233 1.642 12.564 0 7 0a1 1 0 1 0 0 2c2.934 0 5.641.502 7.589.994q-.187.093-.376.19C12.534 4.036 10.631 5 7 5a1 1 0 1 0 0 2c2.733 0 4.631-.498 6.122-1.099a5 5 0 0 0 .152 2.731c-8.12 2.132-9.821 8.986-10.176 11.697a2 2 0 1 0-1.15 3.67L2 24h21a1 1 0 1 0 0-2M22 8c0 1.468-2.392 2-4 2-1.654 0-3-1.346-3-3s1.346-3 3-3c2.481 0 4 2.59 4 4m-7.638 2.426A4.99 4.99 0 0 0 18 12q.502 0 1-.047V22h-2v-1c0-3.309-2.691-6-6-6a1 1 0 1 0 0 2c2.206 0 4 1.794 4 4v1H5.002l.002-.548c.001-.37.146-8.981 9.358-11.026"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rabbit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRabbit;
